export { useHasAuthentication } from './useHasAuthentication';
